// extracted by mini-css-extract-plugin
module.exports = {"customScrollbar":"NotificationPopup_customScrollbar__OyJdV"};